import { IPageCollection, PageCollection } from "./survey-engine/page";
import { EndingInputDataBase } from "./ending";
import { IEndingOutputBase, EndingOutputBase } from "./ending-output-base";
import { URLType } from "../enums/url-type";

export interface IAfterCompleteConsent extends  IEndingOutputBase{
  pages: IPageCollection;
  redirectUrl: string;
  urlType:URLType;
}

export class SetStatusAfterCompleteConsentOutputData extends EndingOutputBase implements IAfterCompleteConsent {
  $type: string =
    "SampleCube.UserFlow.API.Models.EndingPage.DTOs.SetStatusAfterCompleteConsentResponseApiDTO, SampleCube.UserFlow.API.Models.EndingPage";
  pages: IPageCollection;
  redirectUrl: string;
  urlType:URLType;
  constructor(options?: IAfterCompleteConsent) {
    super(options as IEndingOutputBase);
    options = options || ({} as IAfterCompleteConsent);
    this.pages = new PageCollection(options.pages || {});
    this.redirectUrl = options.redirectUrl || "";
    this.urlType=options.urlType || URLType.None;
  }
}
